module.exports = __webpack_public_path__ + "img/CommunalFacility.1cc1f90a.svg";